import { PureComponent, type ComponentType } from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl, type IntlShape, type MessageDescriptor } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { setPageTitle } from '../../redux/actions/routes';

class PageTitle extends PureComponent<{
  setPageTitle: (message: string) => void;
  children: MessageDescriptor;
  intl: IntlShape;
}> {
  componentDidMount() {
    this.props.setPageTitle(this.getTitle());
  }

  componentDidUpdate() {
    this.props.setPageTitle(this.getTitle());
  }

  getTitle() {
    return (
      this.props.children && this.props.intl.formatMessage(this.props.children)
    );
  }

  render() {
    return (
      <Helmet>
        <title>{this.getTitle()}</title>
      </Helmet>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setPageTitle: (title: MessageDescriptor) => dispatch(setPageTitle(title)),
});

export default compose(
  injectIntl,
  connect(null, mapDispatchToProps),
)(PageTitle) as ComponentType<{
  children: MessageDescriptor;
}>;
